'use strict';

import type { UserIntegrationOAuth } from '../../Entities/User/UserIntegrationOAuth';
import { EntityCollection } from '../EntityCollection';

export class UserIntegrationOAuthCollection extends EntityCollection<UserIntegrationOAuth> {}
